import { FaRegCircle, FaCircle } from 'react-icons/fa6';

export default function Descriptor(props) {
   const checked= props.value===1;

   function onClick(e) {
      props.setValue(props.descriptor.id,checked ? 0 : 1);
   }

   return (
      <tr onClick={onClick} className={`answer descriptor descriptor${props.descriptor.id}`}>
         <td className={`checkbox ${checked?"checked":""}`}  >
               {checked?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
               }
         </td>
         <td className="descriptor term">{props.descriptor.name}</td>
         <td className="descriptorDesc definition">{props.descriptor.description}</td>
      </tr >
   );
}